const subUsersIT = {
    "view": {
        "table": {
            "title": "La tua lista di sotto-utenti",
            "column": {
                "username": "Nome utente",
                "email": "Email",
                "first_name": "Nome",
                "last_name": "Cognome",
                "company": "Azienda",
                "sub_user_deal": "Accordo (%)",
                "contract_expiry": "Scadenza contratto",
                "is_active": "Attivo",
                "action": "Azione"
            },
            "button": {
                "edit": "Modifica",
                "export_csv": "Esporta CSV"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "label": {
                "yes": "Sì",
                "no": "No"
            },
            "dropdown": {
                "action": "Azione",
                "edit": "Modifica",
                "activate": "Attiva",
                "deactivate": "Disattiva"
            }
        },
        "message": {
            "successUpdated": "L'account del sotto-utente è stato aggiornato!",
            "successActivated": "L'account del sotto-utente è stato attivato!",
            "successDeactivated": "L'account del sotto-utente è stato disattivato!",
            "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!",
            "premiumUsersOnly": "Questa funzione è offerta solo agli utenti Premium. Si prega di contattare il team di supporto se si desidera aggiornare il proprio account.",
            "noAccess": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni."
        },
        "modal": {
            "activateSubuser": {
                "header": "Attiva Sotto-utente",
                "body": "Sei sicuro di voler attivare il sotto-utente {{username}}?"
            },
            "deactivateSubuser": {
                "header": "Disattiva Sotto-utente",
                "body": "Sei sicuro di voler disattivare il sotto-utente {{username}}?"
            },
            "button": {
                "cancel": "Annulla",
                "edit": "Modifica",
                "activate": "Attiva",
                "deactivate": "Disattiva"
            }
        }
    },
    "add": {
        "title": "Aggiungi Sotto-utente",
        "form": {
            "label": {
                "personalDetails": "Dettagli Personali",
                "firstName": "Nome",
                "lastName": "Cognome",
                "email": "Email",
                "username": "Nome utente",
                "password": "Password",
                "confirmPassword": "Conferma Password",
                "businessDetails": "Dettagli Aziendali",
                "companyName": "Nome Azienda",
                "contractExpiry": "Scadenza contratto",
                "subUserDeal": "Accordo Sotto-utente (%)",
                "nationalTaxNumber": "Numero Fiscale Nazionale",
                "businessRegistrationNumber": "Numero di Registrazione Aziendale",
                "contactDetails": "Dettagli di Contatto",
                "streetAndNumber": "Via e numero civico",
                "postalCode": "Codice Postale",
                "city": "Città",
                "country": "Paese",
                "phoneNumber": "Numero di Telefono"
            },
            "help_text": {
                "contractExpiry": "Nota: La data di scadenza del contratto non può essere impostata prima di {{afterOneYear}}."
            },
            "button": {
                "submit": "Invia"
            }
        },
        "message": {
            "success": "Il sotto-utente è stato aggiunto!",
            "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!"
        },
        "modal": {
            "header": "Aggiungi Sotto-utente",
            "body": "Sei sicuro di voler creare un nuovo sotto-utente?"
        }
    },
    "update": {
        "title": "Modifica Sotto-utente",
        "form": {
            "label": {
                "personalDetails": "Dettagli Personali",
                "firstName": "Nome",
                "lastName": "Cognome",
                "email": "Email",
                "username": "Nome utente",
                "password": "Password",
                "confirmPassword": "Conferma Password",
                "businessDetails": "Dettagli Aziendali",
                "companyName": "Nome Azienda",
                "contractExpiry": "Scadenza contratto",
                "subUserDeal": "Accordo Sotto-utente (%)",
                "nationalTaxNumber": "Numero Fiscale Nazionale",
                "businessRegistrationNumber": "Numero di Registrazione Aziendale",
                "contactDetails": "Dettagli di Contatto",
                "streetAndNumber": "Via e numero civico",
                "postalCode": "Codice Postale",
                "city": "Città",
                "country": "Paese",
                "phoneNumber": "Numero di Telefono"
            },
            "help_text": {
                "contractExpiry": "Nota: La data di scadenza del contratto non può essere impostata prima di {{afterOneYear}}."
            },
            "button": {
                "submit": "Invia"
            }
        },
        "message": {
            "success": "Il sotto-utente è stato aggiornato!",
            "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!"
        }
    }
};

export default subUsersIT;